<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Reporte cronograma
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-15">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <label>Seleccionar programa<span class="required"></span></label>
                <ng-container *ngIf="tourSelected != null">
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm" disabled
                      value="{{tourSelected.description}}">
                    <div class="input-group-append bg-custom b-0 removeClient" ng-if="transport != null">
                      <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                        uib-tooltip="Quitar" (click)="removeTour()">
                        <i class="fas fa-backspace w-100 f-s-12"></i>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="tourSelected == null">
                  <div class="input-group input-group-grid">
                    <component-search-tour [classSize]="'search-small'" (selectedTourEvent)="selectedTourSearch($event)"
                      class="w-100"></component-search-tour>
                    <div class="input-group-append b-0">
                      <div class="input-group-text w-100 text-center pointer" style="padding: 2px 7px;">
                        <!-- <i class="fas fa-user-plus w-100"></i> -->
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="is_all" [(ngModel)]="is_all"
                            (change)="isAll()">
                          <label class="custom-control-label p-t-3" for="is_all">Todos</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="form-group col-lg-3">
                <label>Vista resumen<span class="required"></span></label>
                <select class="form-control" [(ngModel)]="ViewSummarySelected" [ngModelOptions]="{standalone: true}"
                  (change)="changeViewSummary()" disabled>
                  <option *ngFor="let item of viewsummary" [value]="item.id">{{ item.description }}</option>
                </select>
              </div>
              <!-- <div class="form-group col-lg-2">
                <label>Seleccionar Año</label>
                <input id="year" type="text" class="form-control" [(ngModel)]="year">
              </div> -->
            </div>
            <div class="row">
              <div class="col-12 text-left">
                <button type="button" class="btn btn-light m-r-10" (click)="reset()">
                  <i class="fas fa-undo"></i></button>
                <button type="button" class="btn btn-light m-r-10" (click)="printer()">
                  <i class="fas fa-print"></i>
                </button>
                <button class="btn btn-primary" (click)="generateReport()">Generar Reporte</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12" id="body_print">
    <div class="card m-b-30">
      <div class="card-body">
        <div class="row">
          <ng-container *ngIf="!generate">
            <div class="col-lg-12">
              <p class="f-s-14 text-center">Seleccionar opción para generar vista <i class="fas fa-table m-l-5"></i></p>
            </div>
          </ng-container>
          <ng-container *ngIf="generate">
            <div class="col-lg-12" *ngIf="ViewSummarySelected == view_yearly.id">
              <div class="table-responsive">
                <table class="table table-hover mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th rowspan="2" class="white-space-nowrap text-center" style="vertical-align: middle !important;">
                        Nombre programa
                      </th>
                      <th colspan="12" class="text-center">
                        Rango Meses (N° PAX)
                      </th>
                      <th rowspan="2" class="text-center">TOTAL PAX</th>
                    </tr>
                    <tr>
                      <ng-container *ngFor="let item of obj_months; let i = index">
                        <th>{{item.name}}</th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="is_all">
                      <ng-container *ngFor="let tour of response_summarytour">
                        <tr>
                          <td>{{tour.description}}</td>
                          <ng-container *ngFor="let item of tour.summary_quantity_yearly; let i = index">
                            <td>
                              <span class="text-danger" *ngIf="item.sum_by_month == 0">{{item.sum_by_month}}</span>
                              <span *ngIf="item.sum_by_month != 0">{{item.sum_by_month}}</span>
                            </td>
                          </ng-container>
                          <td class="text-center">
                            <span class="bold">{{tour.totales_pax}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!is_all">
                      <ng-container *ngIf="response_summarytour != null">
                        <tr>
                          <td>{{response_summarytour.description}}</td>
                          <ng-container
                            *ngFor="let item of response_summarytour.summary_quantity_yearly; let i = index">
                            <td>
                              <span class="text-danger" *ngIf="item.sum_by_month == 0">{{item.sum_by_month}}</span>
                              <span *ngIf="item.sum_by_month != 0">{{item.sum_by_month}}</span>
                            </td>
                          </ng-container>
                          <td class="text-center">
                            <span class="bold">{{response_summarytour.totales_pax}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
                style="width: 100%; height: 400px; display: block;">
              </highcharts-chart> -->
          </ng-container>
        </div>
        <div class="col-lg-12" *ngIf="ViewSummarySelected == view_monthly.id">
          <p>Resumen Mensual</p>
        </div>
      </div>
    </div>
  </div>
</div>
